(() => {
  const instances = [];

  function whenPageLoaded(callback) {
    if (document.readyState === 'complete') {
      callback();
      return;
    }

    window.addEventListener('load', callback, { once: true });
  }

  function getNumber(value, fallback) {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function getLimit(instance) {
    return window.innerWidth <= 768 ? instance.visibleMobile : instance.visibleDesktop;
  }

  function getEligibleItems(instance) {
    return Array.from(instance.grid.querySelectorAll('.sg-item')).filter(function (item) {
      return window.getComputedStyle(item).display !== 'none';
    });
  }

  function setToggle(instance, expanded) {
    if (instance.toggleText) {
      instance.toggleText.textContent = expanded ? 'SHOW LESS' : 'SHOW MORE';
    }

    if (instance.toggleIcon) {
      instance.toggleIcon.classList.toggle('rotated', expanded);
    }
  }

  function applyLimit(instance) {
    Array.from(instance.grid.querySelectorAll('.sg-item')).forEach(function (item) {
      item.classList.remove('sg-hidden');
    });

    const items = getEligibleItems(instance);
    const limit = getLimit(instance);

    if (items.length <= limit) {
      instance.toggle.style.display = 'none';
      return;
    }

    instance.toggle.style.display = 'flex';

    if (instance.container.classList.contains('sg-expanded')) {
      return;
    }

    items.forEach(function (item, index) {
      if (index >= limit) {
        item.classList.add('sg-hidden');
      }
    });
  }

  function initContainer(container) {
    if (container.dataset.sgBound === '1') {
      return null;
    }

    const grid = container.querySelector('.sg-grid');
    const toggle = container.querySelector('.sg-toggle');

    if (!grid || !toggle) {
      container.classList.remove('sg-init');
      container.classList.add('sg-ready');
      return null;
    }

    const instance = {
      container: container,
      grid: grid,
      toggle: toggle,
      toggleText: toggle.querySelector('.sg-toggle-text'),
      toggleIcon: toggle.querySelector('.sg-toggle-icon'),
      visibleDesktop: getNumber(container.dataset.visibleDesktop, 4),
      visibleMobile: getNumber(container.dataset.visibleMobile, 4),
      isLoading: false,
      loadingTimer: null,
    };

    container.classList.remove('sg-expanded');
    setToggle(instance, false);
    applyLimit(instance);

    whenPageLoaded(function () {
      container.classList.remove('sg-init');
      container.classList.add('sg-ready');
      applyLimit(instance);
    });

    toggle.addEventListener('click', function (event) {
      event.preventDefault();

      if (instance.isLoading) {
        return;
      }

      const isExpanded = container.classList.contains('sg-expanded');

      if (isExpanded) {
        container.classList.remove('sg-expanded');
        setToggle(instance, false);
        applyLimit(instance);
        return;
      }

      instance.isLoading = true;
      container.classList.add('sg-loading');

      if (instance.toggleText) {
        instance.toggleText.textContent = 'LOADING...';
      }

      if (instance.loadingTimer) {
        window.clearTimeout(instance.loadingTimer);
      }

      const delay = 500;

      instance.loadingTimer = window.setTimeout(function () {
        instance.isLoading = false;
        container.classList.remove('sg-loading');
        container.classList.add('sg-expanded');
        setToggle(instance, true);
        applyLimit(instance);
      }, delay);
    });

    container.dataset.sgBound = '1';

    return instance;
  }

  function initAll(root) {
    const scope = root || document;
    const containers = [];

    if (scope.nodeType === 1 && scope.matches && scope.matches('.sg-container')) {
      containers.push(scope);
    }

    containers.push(...Array.from(scope.querySelectorAll('.sg-container')));

    containers.forEach(function (container) {
      const instance = initContainer(container);
      if (instance) {
        instances.push(instance);
      }
    });
  }

  let resizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      instances.forEach(function (instance) {
        if (!instance.container.classList.contains('sg-expanded')) {
          applyLimit(instance);
        }
      });
    }, 120);
  });

  document.addEventListener('sg:refresh', function () {
    instances.forEach(function (instance) {
      applyLimit(instance);
    });
  });

  document.addEventListener('sg:init', function (event) {
    initAll(event.detail && event.detail.root ? event.detail.root : document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
